/**
 * Provides a menu button for rapid ad-hoc status value changes
 */
export class StatusMenuButtonController {
  public static $inject = ['$scope'];
  public availableStatuses: Array<string> = [];
  public currentStatus: string;
  public setStatus: Function;
  public getAvailableStatuses: Function;
  public disabled: boolean;

  constructor($scope) {
    if (angular.isFunction(this.getAvailableStatuses)) {
      $scope.$watch('vm.currentStatus', () => {
        this.setAvailableStatuses(this.currentStatus);
      });
    }
  }

  /**
   * Invokes the function bound to the directive's setStatus scope property passing on the supplied status enum value
   *
   * @param status The status value
   */
  public setStatusValue = (status: string) => {
    this.setStatus({ newStatus: status });
  };

  /**
   * Determines whether this component should be disabled
   * @returns A true/false flag for whether this component should be disabled
   */
  public isDisabled = () => {
    if (!this.disabled && this.availableStatuses) {
      return this.availableStatuses.length === 0;
    }
    return true;
  }

  /**
   * Assigns the result of invoking the function bound to the directive's getAvailableStatuses scope property passing on the supplied status enum value.
   *
   * @param status A status value
   */
  public setAvailableStatuses = (status: string) => {
    this.availableStatuses = this.getAvailableStatuses({ status: status });
  }
}